// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".register[data-v-7df107fe] {\n  padding-left: 40px;\n  box-sizing: border-box;\n}\n.register-form[data-v-7df107fe] {\n  margin-top: 20px;\n}\n.register .tabs[data-v-7df107fe] {\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  user-select: none;\n}\n", ""]);
// Exports
module.exports = exports;
